import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Tab1 from './tab1';

class RegistrationForm extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }

    componentWillMount() {

    }

    render() {
        const { props } = this;
        return (
            <div className="container-fluid">
                <TransitionGroup>
                    <CSSTransition key={props.location.key} classNames="fade" timeout={300}>
                        <Switch location={props.location}>
                            <Route exact path="/portal/consent" component={Tab1} />
                            <Route
                                render={(props2) => {
                                    window.location = `/404.html?from=${props2.location.pathname}`;
                                }}
                            />
                        </Switch>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );
    }
}

export default RegistrationForm;



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration-v2/index.js
// module id = 774
// module chunks = 0